import * as React from 'react';
import { Link } from 'react-router-dom';

const TcsExpress = () => {

    React.useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
   
    return(
    <div >
        <div id='express' >
            <img src='/ExpressBanner/banner-2.jpg' alt='' className='w-[100%]'/>
        </div>
        <div className="flex flex-col justify-center  gap-4 lg:max-w-[50rem] max-w-[30rem] sm:max-w-[36rem] lg:mx-auto mx-[2rem] sm:mx-[auto]  lg:pr-[3rem] lg:pl-[3rem] lg:pt-[2rem] pt-[1rem]  pb-[1rem]">
            <p>
                In 1983, with twelve Express Centres and twenty-five shipments is where it started for TCS. Now with
                a network of more than 1,000 retail centres in the country, backed by a fleet of 4,500+ delivery 
                conveyances and an aviation division, TCS Express is the largest courier and logistics network in Pakistan.
            </p>
            <p>
                Busy serving customers 24 hours a day, Express operation is the bedrock of TCS products and services. 
                Five different classes of TCS Express Centres, including COCO, Franchised, Shop-in-Shop, Agents and IBRS, 
                serve as a one-stop-shop for our customers.
            </p>
        </div>    

        <div className="max-w-[70rem] lg:mx-auto flex lg:flex-col lg:flex-row justify-between items-center pt-[2rem] pb-[100px]">
            <div className="lg:flex sm:flex grid sm:justify-center justify-bteween gap-6 flex-1 lg:pr-[2rem] ">
                <div className="flex justify-between flex-col gap-6">
                    
                    <Link to="/domestic-express" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem]  lg:mx-[0rem] sm:mx-[0rem] mx-[2rem]  px-[10px] py-[12px] rounded-md'> 
                    <img src='/Home/expressIcons/domesticexpress.svg' className='tcs-express-logo w-[100px]'/>
                    </Link>

                    <Link to="/aviation" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem]  lg:mx-[0rem] sm:mx-[0rem] mx-[2rem] px-[10px] py-[18px] rounded-md'> 
                    <img src='/Home/expressIcons/aviation.svg' className='w-[100px] h-[14px]'/>
                    </Link>

                    <Link to="/ecom-solution" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] lg:mx-[0rem] sm:mx-[0rem] mx-[2rem] px-[10px] py-[12px] rounded-md'> 
                    <img src='/Home/expressIcons/ecom.svg' className='tcs-express-logo w-[100px]'/>
                    </Link>
                       
                    <Link to="/visatronix" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] lg:mx-[0rem] sm:mx-[0rem] mx-[2rem] px-[23px] py-[18px] rounded-md'> 
                    <img src='/Home/expressIcons/visatronix.svg' className='w-[100px]'/>
                    </Link>
                </div>
                
                <div className="flex flex-col gap-6">
                    <Link to="/international-express" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] lg:mx-[0rem] sm:mx-[0rem] mx-[2rem] px-[23px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/internationalexpress.svg' className='tcs-express-logo w-[100px]'/>
                    </Link>

                    <Link to="/financial-services" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] lg:mx-[0rem] sm:mx-[0rem] mx-[2rem] px-[16px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/financial.svg' className='w-[100px] tcs-express-logo'/>
                    </Link>

                    <Link to="/intiana-travel" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] lg:mx-[0rem] sm:mx-[0rem] mx-[2rem] px-[25px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/intianatraveltours.svg' className='w-[100px] tcs-express-logo'/>
                    </Link>

                    <Link to="/mms" className='shadow-card lg:w-[20rem] w-[16rem] md:w-[17rem] lg:mx-[0rem] sm:mx-[0rem] mx-[2rem] px-[6px] py-[15px] rounded-md'> 
                        <img src='/Home/expressIcons/mms.svg' className='w-[100px] h-[18px]'/>
                    </Link>
                </div>
            </div>
        </div>
    </div>
    )
};

export default TcsExpress;